{
	"button": {
		"report": "Ilmianna ilmoitus",
		"reported": "Ilmiannettu"
	},
	"dialog": {
		"title": "Ilmianna ilmoitus"
	},
	"reasons": {
		"spam": "Roskaposti — väärä, kopioitu tai mainostava",
		"misleadingDescription": "Harhaanjohtava kuvaus — ei vastaa oikeaa kiekkoa",
		"inappropriateImage": "Sopimaton kuva — loukkaavaa tai aikuissisältöä",
		"wrongDisc": "Väärä kiekko — väärä kiekkomalli valittu",
		"other": "Muu — selitä alla"
	},
	"form": {
		"optionalNote": "Vapaaehtoinen huomio…",
		"cancel": "Peruuta",
		"submit": "Lähetä ilmianto",
		"submitting": "Lähetetään…"
	},
	"toasts": {
		"submitted": "Ilmianto lähetetty. Kiitos.",
		"alreadyReported": "Olet jo ilmiantanut tämän ilmoituksen.",
		"failed": "Ilmiannon lähetys epäonnistui. Yritä uudelleen."
	}
}
